






















import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Rectangle, Point, Size, LineStyle, Color, LineKinds } from "../../../../../domain/drawing";
import { IItem, IDrawableItem, PolylineItem, TypeKeys } from "../../../../../domain/document/items";
import { NewSignObjectKeys } from "../../../../../domain/configuration";
import { DomainRegistry } from "../../../../../domain";
import { ModelEditableMixin } from "../../../../system";
import { StandardOption } from "../../../../system/selectors/mixins";
import { CommonComponentsAccessibleMixin, DocumentStructureEditableMixin } from "../../mixins";
import { LineDrawerPropertyEditableMixin } from "../../propertyEditors/mixins";
import SignPropertyEditor from "./SignPropertyEditor.vue";

interface IToolContent {
  name: string;
  source: IItem;
  options?: StandardOption<any>[];
  process: (source: IItem) => void;
}

@Component({
  components: {
    SignPropertyEditor,
  },
})
export default class Header extends Mixins(ModelEditableMixin, CommonComponentsAccessibleMixin, DocumentStructureEditableMixin, LineDrawerPropertyEditableMixin) {
  data(): any {
    return {
      shouldDrawContinuously: false,
      isProcessing: false,
      selectedTool: null,
    };
  }
  shouldDrawContinuously: boolean;
  isProcessing: boolean;
  selectedTool: IToolContent;

  readonly Tools: {[key: string]: IToolContent} = {
    pen: {
      name: "ペン",
      source: null,
      process: (source: PolylineItem) => this.layoutPoints(source),
    },
    marker: {
      name: "マーカー",
      source: (() => {
        const result = new PolylineItem();
        result.privateId = undefined;
        result.uniqueKey = undefined;
        result.id = undefined;
        result.sectionObjectUid = undefined;
        result.isEditable = true;
        result.isAdditional = true;
        result.isDeleted = false;
        result.isVisible = true;
        result.typeDetail = undefined;
        result.viewTitle = undefined;
        result.printBehavior.shouldPrint = true;
        result.printBehavior.shouldPreview = true;
        result.geometry.rectangle = new Rectangle(new Point(Infinity, Infinity), new Size(Infinity, Infinity));
        result.lineStyle = new LineStyle(new Color("#FF7F00"), LineKinds.Normal, 15, 0.3);
        result.points = [];
        return result;
      })(),
      options: Enumerable.from([5, 10, 15, 20, 25]).select(i => new StandardOption<number>(i + "px", i)).toArray(),
      process: (source: PolylineItem) => this.layoutPoints(source),
    },
  };

  async created() {
    this.Tools.pen.source = await this.createSource("NewPen");
  }

  async createSource<T extends IDrawableItem = IDrawableItem>(signKey: NewSignObjectKeys): Promise<T> {
    const source = await DomainRegistry.document.getDocumentRepository().createNewSignObjects(signKey) as T;
    return source;
  }

  get pallet(): Color[] {
    return Enumerable.from(this.$configuration.style.document.editor.colorPallets)
      .where(x => !!x && x !== "")
      .distinct()
      .select(c => new Color(c))
      .toArray();
  }

  get isPolylineItemSelected(): boolean {
    return !!this.lastFocusedItem && this.lastFocusedItem.typeKey === TypeKeys.PolylineItem;
  }

  get editTools(): IToolContent[] {
    return [
      this.Tools.pen,
      // this.Tools.marker,
      // マーカーはPDFで文字色の透過に対応できたら使用可能
      // iTextSharp 4.1.6ではRGBAに対応していないため現状では難しい
    ];
  }

  get options(): StandardOption<any>[] {
    return this.selectedTool && this.selectedTool.options
      ? this.selectedTool.options
      : null;
  }

  get source(): IItem {
    return this.selectedTool && this.selectedTool.source
      ? this.selectedTool.source
      : null;
  }

  set source(source: IItem) {
    this.selectedTool.source = source;
    this.reprocess(source);
  }

  isSelected(tool: IToolContent): boolean {
    return this.selectedTool === tool;
  }

  @Watch("selectedTool")
  onSelectedToolChanged(newValue: IToolContent, oldValue: IToolContent) {
    if ((oldValue && oldValue !== newValue) || !newValue) {
      this.cancel();
    }
    if (newValue && newValue.source && newValue.process) {
      newValue.process(newValue.source);
    }
  }

  reprocess(item: IItem): void {
    if (this.isProcessing) { this.cancel(); }
    this.layoutPoints(item as PolylineItem);
  }

  layoutPoints(item: PolylineItem): void {
    this.processRequest(async () => {
      try {
        const p = await this.commonComponents.editors.page.layoutPointsItem(this, item);
        if (!p) {
          return;
        }
        item.points = p;
        this.addItem(item.clone());
        if (this.shouldDrawContinuously) {
          this.isProcessing = false;
          this.layoutPoints(item);
        } else {
          this.selectedTool = null;
        }
      } catch (e) {
        this.$error(
          "オブジェクト追加失敗",
          "オブジェクト追加操作中にエラーが発生しました.",
          e
        );
      }
    });
  }

  private processRequest(callback: () => void): void {
    if (!this.source) {
      throw new Error("ソースが設定されていません.実装を確認してください.");
    }
    this.isProcessing = true;
    callback(); // tickで待つのはLocator側に任せる.
  }

  cancel(): void {
    this.commonComponents.editors.page.cancel(this);
    this.isProcessing = false;
  }

  remove(): void {
    this.removeItem(this.lastFocusedItem);
  }

  changeSelectedTool(tool: IToolContent): void {
    this.selectedTool = tool;
  }
}
